import Text from '@service-victoria/component-library/components/Text';
import { storage as st } from '@service-victoria/component-library/utils/storage';
import axios from 'axios';
import type { SpecialComponents } from 'react-markdown/lib/ast-to-react';
import type { NormalComponents } from 'react-markdown/lib/complex-types';

import { Spacer16 } from './styled';

type ContentSlotItem = {
  data: string;
  ts: number;
};

const ls = st<ContentSlotItem>(localStorage);
const StorageKey = 'rcr';

/**
 * Storage helper - wraps requests with the storage key being used
 */
export const storage = {
  key: StorageKey,
  getItem: (key: string) => ls.getItem(`${StorageKey}.${key}`),
  setItem: (key: string, value: ContentSlotItem) => ls.setItem(`${StorageKey}.${key}`, value),
  clearMatching: (regex: RegExp) => {
    for (const item in localStorage) {
      if (localStorage.hasOwnProperty(item)) {
        if (item.match(regex)) {
          ls.removeItem(item);
        }
      }
    }
  }
};

/**
 * Service for fetching the data and maintaining type safety
 */
export const service = {
  getSlot: async (content: string) => {
    const { data } = await axios.get<string>(content);
    return data;
  }
};

/**
 * Custom component mappings
 */
export const mdComponentMap: Partial<
  Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents
> = {
  p({ children }) {
    return <Text.Body>{children}</Text.Body>;
  },
  a({ children, href }) {
    return <Text.Link href={href}>{children}</Text.Link>;
  },
  h1({ children }) {
    return (
      <>
        <Text.Heading.H1 fontWeight={600}>{children}</Text.Heading.H1>
        <Spacer16 />
      </>
    );
  },
  h2({ children }) {
    return <Text.Heading.H2 fontWeight={600}>{children}</Text.Heading.H2>;
  },
  h3({ children }) {
    return <Text.Heading.H3 fontWeight={600}>{children}</Text.Heading.H3>;
  }
};
